<section class="portal-list-page">
  <header class="portal-list-page__header" *ngIf="title || subtitle">
    <div class="portal-list-page__heading" *ngIf="title || subtitle">
      <h1 *ngIf="title">{{ title }}</h1>
      <p *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <div class="portal-list-page__header-content">
      <ng-content select="[portalListHeader]"></ng-content>
    </div>
  </header>

  <div class="portal-list-page__toolbar">
    <ng-content select="[portalListToolbar]"></ng-content>
  </div>

  <div class="portal-list-page__surface">
    <ng-content></ng-content>
  </div>
</section>
